import { render, staticRenderFns } from "./select-contants.vue?vue&type=template&id=ff400e2c&"
import script from "./select-contants.vue?vue&type=script&lang=js&"
export * from "./select-contants.vue?vue&type=script&lang=js&"
import style0 from "./select-contants.vue?vue&type=style&index=0&id=ff400e2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports